// extracted by mini-css-extract-plugin
export default {"box":"header-module__box___066402","content":"header-module__content___138997","close":"header-module__close___ede6c7"};